import React, { useEffect, useState } from 'react';
import './QuranPage.css'; 
import { useSearchParams, useNavigate } from 'react-router-dom';
import back from './../assets/icon/back.svg';
import { useDispatch } from 'react-redux';
import { editReview } from '../actions/appAction';
import { updateStreak } from '../utils/streak';


const QuranPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const [ayahs, setAyahs] = useState([]);
  const [highlightRange, setHighlightRange] = useState({ start: null, end: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [rating, setRating] = useState(null);

  

  // Extract the query params
  const pageParam    = searchParams.get('page')   || '1';
  const startParam   = searchParams.get('start')  || '1';
  const endParam     = searchParams.get('end')    || '1';
  const surahParam   = searchParams.get('id')  || '1';
  const reviewId     = searchParams.get('review_id');

  console.log('Page:', pageParam);
  // Comma-separated list of pages, e.g. "52,53"
  const pagesParam   = searchParams.get('pages')  || pageParam; 
  console.log('Pages:', pagesParam);
  // Convert that string into an array of numbers
  const pagesArray   = pagesParam.split(',').map(p => parseInt(p, 10));
  console.log('Pages Array:', pagesArray);

  // Current page as a number
  const currentPageNumber = parseInt(pageParam, 10);

  // Find the current page index in pagesArray
  const currentIndex = pagesArray.findIndex(p => p === currentPageNumber);
  console.log('Current Index:', currentIndex);

  // Fetch the Quran page
  useEffect(() => {
    async function fetchQuranPage() {
      try {
        setLoading(true);
        const response = await fetch(
          `https://api.alquran.cloud/v1/page/${currentPageNumber}/quran-uthmani`
        );
        const data = await response.json();
        console.log('Fetched Data:', data);

        if (data.code === 200) {
          setAyahs(data.data.ayahs);
          setHighlightRange({
            start: parseInt(startParam, 10),
            end: parseInt(endParam, 10)
          });
          setLoading(false);
        } else {
          throw new Error(data.status);
        }
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    }
    fetchQuranPage();
  }, [currentPageNumber, startParam, endParam]);
  const handleRatingClick = async (value) => {
    setRating(value);
    if (!reviewId) return;
    try {
      await dispatch(editReview({ review_id: reviewId, request_type: 'add', rating: value }));
      updateStreak(value);
      navigate('/home');
    } catch (e) {
      console.error(e);
    }
  };


  if (loading) {
    return (
      <div className="quran-app">
        <div className="quran-page-container">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p className="loading-text">جارٍ تحضير الايات</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="quran-app">
        <div className="quran-page-container">
          Error: {error}
        </div>
      </div>
    );
  }

  // Decide if we highlight a given ayah
  const shouldHighlight = (ayah) => {
    const surahNum = parseInt(surahParam, 10);
    const ayahNum = ayah.numberInSurah;
    // Must match both the surah AND be in the (start..end) ayah range
    return (
      ayah.surah.number === surahNum &&
      ayahNum >= highlightRange.start &&
      ayahNum <= highlightRange.end
    );
  };
  

  // Handlers to go to next/previous pages in the array
  const goToPage = (page) => {
    navigate(
      `/quran?pages=${pagesParam}` +
      `&page=${page}` +
      `&start=${startParam}` +
      `&end=${endParam}` +
      `&id=${surahParam}` +
      (reviewId ? `&review_id=${reviewId}` : '')    );
  };

  // Determine availability
  const hasPrev = currentIndex > 0;
  const hasNext = currentIndex < pagesArray.length - 1;
  const bismillahRegex = /^بِسْمِ\s*[ٱا]للَّهِ\s*[ٱا]لرَّحْمَٰنِ\s*[ٱا]لرَّحِيمِ/;
  const ratingOptions = [
    { value: 1, label: 'سيئ' },
    { value: 2, label: 'جيد' },
    { value: 3, label: 'ممتاز' },
    { value: 4, label: 'سهل' },
  ];



  return (
    <div className="quran-app">
      {/* Optionally add "quran-Othmani" if you want that fallback chain */}
      <div className="quran-header">
        <div className="back-button-container">
          <img
            className="back-icon"
            src={back}
            alt="Back"
            onClick={() => navigate('/home')}
          />
        </div>
        <h1 className="surah-name">
          {ayahs[0].surah.name}
        </h1>
      </div>
      <div className="quran-page-container quran-Othmani">
        {/* The inline text container */}
        <div className="quran-text">
        {ayahs.map((ayah) => {
            // If it's the first ayah in the surah,
            // remove the leading Basmalah from the text, and show Basmalah separately.
            if (ayah.numberInSurah === 1) {
              // Remove leading basmalah
              const textWithoutBismillah = ayah.text
                .replace(bismillahRegex, "")
                .trim();

              return (
                <React.Fragment key={ayah.number}>
                  <div className="bismillah">
                    بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ
                  </div>
                  {textWithoutBismillah && (
                    <span
                      className={`ayah ${shouldHighlight(ayah) ? "highlight-ayah" : ""}`}
                    >
                      {textWithoutBismillah}
                      <span className="ayah-number">
                        {ayah.numberInSurah}
                      </span>{" "}
                    </span>
                  )}
                </React.Fragment>
              );
            } else {
              // Normal rendering for all other ayahs
              return (
                <span
                  key={ayah.number}
                  className={`ayah ${shouldHighlight(ayah) ? "highlight-ayah" : ""}`}
                >
                  {ayah.text}
                  <span className="ayah-number">{ayah.numberInSurah}</span>{" "}
                </span>
              );
            }
          })}
        </div>


        <div>
          <p className="page-number">صفحة {currentPageNumber}</p>
        </div>
        <div className="page-buttons">
          {pagesArray.length > 1 && (
            <div className="page-nav-container">
              <button
                className="page-nav-button"
                onClick={() => goToPage(pagesArray[currentIndex - 1])}
                disabled={!hasPrev}
              >
                الصفحة السابقة
              </button>

              <button
                className="page-nav-button"
                onClick={() => goToPage(pagesArray[currentIndex + 1])}
                disabled={!hasNext}
              >
                الصفحة التالية
              </button>
            </div>
          )}
          {reviewId && (
            <div className="rating-container">
              <div className="rating-buttons">
              {ratingOptions.map(({ value, label }) => (
                  <button
                  key={value}
                  className={`rating-btn rating-${value}${rating === value ? ' selected' : ''}`}
                  onClick={() => handleRatingClick(value)}
                  >
                    {label}
                  </button>
                ))}
              </div>
              {/* <button
                className="page-nav-button"
                onClick={handleSubmitRating}
                disabled={rating === null}
              >
                حفظ التقييم
              </button> */}
            </div>
          )}

        </div>


      </div>
    </div>
  );
};

export default QuranPage;
